import utilActions from '@/api/actions';
import printReportAction from '@/components/nsw-components/PrintReportsAction';

// Mark as Incorrect Action
const markAsIncorrectAction = {
	id: 'markAsIncorrect',
	selectionType: 'single',
	label: 'action.portcallinvoices.markAsIncorrect',
	functionality: 'WRITE_PORTCALLINVOICES',
	showInForm: true,

	checkAvailability: function (registries) {
		// Only available for PAID invoices (status = 2)
		return registries.length === 1 && registries[0].invoicestatusid === 2;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = utilActions.getPkFromModel(model, row);
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-portcallinvoicesMarkAsIncorrect-' + model.name + '-show', row);
	}
};

// Finalize Invoice Action
const finalizeInvoiceAction = {
	id: 'finalizeInvoice',
	selectionType: 'single',
	label: 'action.portcallinvoices.finalizeInvoice',
	functionality: 'WRITE_PORTCALLINVOICES',
	showInForm: true,
	checkAvailability: function (registries) {
		// Only available for PAID invoices (status = 2)
		return registries.length === 1 && registries[0].invoicestatusid === 2;
	},
	runAction: function (action, model, registries) {
		const row = registries[0];
		const objectPk = utilActions.getPkFromModel(model, row);
		row.headerPk = objectPk;
		row.isAction = true;
		this.$puiEvents.$emit('pui-modalDialogForm-portcallinvoicesFinalizeInvoice-' + model.name + '-show', row);
	}
};

export default {
	gridactions: [
		markAsIncorrectAction,
		finalizeInvoiceAction,
		printReportAction.printReport('PORT_CALLS_INVOICES_REPORT', 'invoiceid', 'reports.label.hydrographicService')
	],
	formactions: [
		markAsIncorrectAction,
		finalizeInvoiceAction,
		printReportAction.printReport('PORT_CALLS_INVOICES_REPORT', 'invoiceid', 'reports.label.hydrographicService')
	]
};
